import React from 'react'
import './index.scss'

const OzNotification = () => (
  <div className="oz-notification">
    <span className="oz-notification__sub">
      Discover Benefits of
    </span>
    <div className="oz-notification__text">
      <img src="/assets/images/factor_logo.png" alt="" />
      <p>ELEMENT Platform for</p>
      <b>
        <div className="oz-notification__text-dynamic">
          Advertising.
          <br />
          Publishing.
          <br />
          Tracing.
          <br />
          Enhancing.
          <br />
          Communication.
          <br />
          Notifications.
        </div>
      </b>
    </div>
  </div>
)

export default OzNotification
